'use client';

import { Button } from '@/components/button';
import { PostcodeSelectCityState, type PostcodeSelectState } from '@/hooks/usePostcodeSelect';
import WarningAmberIcon from '@/public/icons/material/warning-amber.svg';
import { Dialog } from '@base-ui/react/dialog';
import classNames from 'classnames';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import classes from './PostcodeInput.module.scss';

const PostcodeInputCity: React.FC<{ state: PostcodeSelectState; onlyDialog?: boolean }> = (props) => {
  const { inputText, cities, loading, cityState, open, setOpen, handleCloseDialog, selectedValue } = props.state;
  const { t } = useTranslation();
  const portalContainerRef = useRef<HTMLDivElement>(null);
  const textDialogTitle = t('postcodeInput.dialogTitle').split('%%postcode%%');

  return (
    <>
      {!Boolean(props.onlyDialog) && (
        <span className={classes.citySlot} aria-hidden={true}>
          {loading && <span className={classes.citySkeleton} data-testid="post-code-city-skeleton" />}
          {!loading && cityState === PostcodeSelectCityState.WARNING && <WarningAmberIcon color="warning" />}
          {!loading && cityState === PostcodeSelectCityState.SINGLE_CITY && (
            <span className={classes.cityName}>{selectedValue.cityName}</span>
          )}
          {!loading && cityState === PostcodeSelectCityState.MULTIPLE_CITIES && (
            <Button
              variant="text"
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                setOpen(true);
              }}
              className={classNames(classes.cityButton, 'underlined')}
              data-testid="post-code-select-city-button"
            >
              {selectedValue.cityName}
            </Button>
          )}
        </span>
      )}
      <div className={classNames(classes.dialogHost, props.onlyDialog && classes.dialogHostDetached)}>
        <Dialog.Root
          open={open}
          onOpenChange={(nextOpen) => {
            if (!nextOpen) {
              setOpen(false);
            }
          }}
        >
          <Dialog.Portal container={props.onlyDialog ? undefined : portalContainerRef}>
            <Dialog.Backdrop className={classes.dialogBackdrop} />
            <Dialog.Popup className={classes.dialogPopup}>
              <div className={classes.dialogTitle}>
                <div>
                  {textDialogTitle[0]}
                  <span className={classes.highlight}>{inputText}</span>
                  {textDialogTitle[1]}
                </div>
              </div>
              <ul className={classes.cityList}>
                {cities.map((cityName) => (
                  <li key={cityName}>
                    <button type="button" className={classes.cityItem} onClick={() => handleCloseDialog(cityName)}>
                      {cityName}
                    </button>
                  </li>
                ))}
              </ul>
            </Dialog.Popup>
          </Dialog.Portal>
        </Dialog.Root>
        {!props.onlyDialog && (
          <div ref={portalContainerRef} className={classes.dialogPortalMount} data-slot="dialog-portal-mount" />
        )}
      </div>
    </>
  );
};

export default PostcodeInputCity;
